// extracted by mini-css-extract-plugin
export var detailsCaret = "_4h-1";
export var detailsExpanded = "_4h-2";
export var itemDetailsContainer = "_4h-0";